var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / status pop up / sorry icon ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-status-pop-up-/-sorry-icon-",
    fill: "#C42323"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2857143,13.7014085 L19.2857143,8 L15.7142857,8 L15.7142857,13.7014085 L16.3849765,19 L18.6150235,19 L19.2857143,13.7014085 Z M20,22.6666667 C20,21.3780023 18.8807119,20.3333333 17.5,20.3333333 C16.1192881,20.3333333 15,21.3780023 15,22.6666667 C15,23.9553311 16.1192881,25 17.5,25 C18.8807119,25 20,23.9553311 20,22.6666667 L20,22.6666667 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1717172,30.9090909 C9.5843565,30.9090909 3.43434343,24.7589596 3.43434343,17.1717172 C3.43434343,9.5843565 9.5843565,3.43434343 17.1717172,3.43434343 C24.7589596,3.43434343 30.9090909,9.58447472 30.9090909,17.1717172 C30.9090909,24.7589596 24.7589596,30.9090909 17.1717172,30.9090909 M17.0000594,0 C7.61173629,0 0,7.61173629 0,17.0000594 C0,26.3894523 7.61173629,34 17.0000594,34 C26.3894523,34 34,26.390522 34,17.0000594 C34,7.61173629 26.3893334,0 17.0000594,0",
    id: "Fill-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.3ef2d040.svg";
export { ForwardRef as ReactComponent };